import React from 'react';
import {NavLink} from 'react-router-dom';
import HeaderNav from '../HeaderNav';
import LabelHello from '../LabelHello';
import SideBarContainer from '../SideBarContainer';
import Item from '../Item';
import NavLinkButton from '../../../../common/components/NavLinkButton';
import ModalCommon from "../../../../common/components/ModalCommon";
import toExam from '../../assets/Exam.jpg';
import toExam_iPad from '../../assets/Exam-iPad.jpg';
import toList from '../../assets/List.jpg';
import toList_iPad from '../../assets/List-iPad.jpg';
import toDatabase from '../../assets/Database.jpg';
import toDatabase_iPad from '../../assets/Database-iPad.jpg';
import toRepository from '../../assets/Repository.jpg';
import toRepository_iPad from '../../assets/Repository-iPad.jpg';
import toAppraisals from '../../../../common/assets/provision.svg';
import toTaxAuthority from '../../../../common/assets/tax-authority.svg';
import {pathnames as P} from '../../../../common/constants/pathnames';
import styles from './styles.module.scss';

const Page = ({firmInspectionsAccess}) => {
  return (
    <div className={styles.mainMenu}>
      <div className={styles.content}>
        <div className={styles.header}>
          <HeaderNav/>
        </div>
        <div className={styles.main}>
          <div className={styles.labelHelloContainer}>
            <LabelHello/>
          </div>
          <div className={styles.window}>
            <div className={styles.form}>
              <NavLinkButton to={P.TASKS} className={styles.navLink}>
                <Item
                  src_desktop={toExam}
                  src_iPad={toExam_iPad}
                  article="המשימות שלי"
                />
              </NavLinkButton>
              <NavLink to={P.INSPECTED_LIST} className={styles.navLink}>
                <Item
                  src_desktop={toList}
                  src_iPad={toList_iPad}
                  article="מאגר הדוחות שלי"
                />
              </NavLink>
              <NavLinkButton
                to={P.ESTIMATES_DATABASE}
                className={styles.navLink}
                disabled={!firmInspectionsAccess}
              >
                <Item
                  src_desktop={toDatabase}
                  src_iPad={toDatabase_iPad}
                  article="מאגר דוחות המשרד"
                  disabled={!firmInspectionsAccess}
                />
              </NavLinkButton>
              <ModalCommon
                header={'מאגרי מידע AI'}
                size={'md'}
                customModalTrigger={
                  <Item
                    src_desktop={toRepository}
                    src_iPad={toRepository_iPad}
                    article="מאגרי מידע AI"
                  />
                }
              >
                <div className={styles.linksContainer}>
                  <NavLinkButton to={P.APPRAISALS} className={styles.navLink}>
                    <div className={styles.internalLink}>
                      <img src={toAppraisals ?? ''} alt="i" className={styles.image}/>
                      <span className={styles.title}>שומות מכריעות</span>
                    </div>
                  </NavLinkButton>
                  <NavLinkButton to={P.TAX_AUTHORITY} className={styles.navLink}>
                    <div className={styles.internalLink}>
                      <img src={toTaxAuthority ?? ''} alt="i" className={styles.image}/>
                      <span className={styles.title}>רשות המיסים</span>
                    </div>
                  </NavLinkButton>
                </div>
              </ModalCommon>
            </div>
          </div>
        </div>
      </div>
      <SideBarContainer/>
    </div>
  );
};

export default Page;